/**
 * The click event to listen to
 * @return {String} Returns `touchstart` if available, otherwise `click
 */
const clickEvent = () => ('touchstart' in window ? 'touchstart' : 'click');
export default clickEvent;
